/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tx_Status_PaidInputs */

const en_tx_status_paid = /** @type {(inputs: Tx_Status_PaidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paid`)
};

const id_tx_status_paid = /** @type {(inputs: Tx_Status_PaidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lunas`)
};

/**
* | output |
* | --- |
* | "Paid" |
*
* @param {Tx_Status_PaidInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tx_status_paid = /** @type {((inputs?: Tx_Status_PaidInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tx_Status_PaidInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tx_status_paid(inputs)
	return en_tx_status_paid(inputs)
});